import Debug from 'debug'
import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { SectionCompletion } from '@/app/statistics/section/section-progress';

const debug = Debug('section-completion-store-module')

@Module({
  namespaced: true,
  name: 'sectionCompletion',
  store,
  dynamic: true
})
class SectionCompletionStoreModule extends VuexModule {
  public completionItemsBySectionId: { [sectionId: string]: SectionCompletion } = {};
  public totalPercent: number = 0;

  @Mutation
  public clear(): void {
    this.completionItemsBySectionId = {}
  }

  @Mutation
  public setCompletion(value: SectionCompletion): void {
    this.completionItemsBySectionId[value.sectionId] = value;
  }

  @Mutation
  public setTotalPercent(value: number): void {
    debug('set-total-percent', value, 'current: ' + this.totalPercent)
    this.totalPercent = value;
  }
}

export default getModule(SectionCompletionStoreModule);
